import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import treeItemReducer from "../features/TreeItem/slice";
import apiCollectionSlice from "../features/ApiCollection/slice";
import globalDataSlice from "../features/Global/slice";
import { ApiCollectionApi } from "../features/ApiCollection/api";
import { ApiCollectionEnvApi } from "../features/ApiCollection/envApi";
import { ApiCollectionWorkspaceApi } from "../features/ApiCollection/workSpaceApi";
import companyApi from "../features/Global/api";
import jiraProjectApi from "../features/jiraProject/api";
import { roleAuthMgmt } from "@/features/RoleAuthMgmt/api";
import roleReducer from "@/features/RoleAuthMgmt/slice";
import rolesSlice from "@/features/Roles/slice";
import emailAuthReducer from "@/features/RoleAuthMgmt/slice";
import { CompanyMgmt } from "@/features/CompanyInformation/companyApi";
import { RoleApi } from "@/features/Roles/api";
import companyMembersReducer from "@/features/Members/slice";
import { IntegrationApi } from "@/features/Integration/api";
import { supportMgmtApi } from "@/features/bughurd/api";
import dataRefetchSlice from "@/features/Integration/slice";
import { SpecificationApi } from "@/features/Integration/specificationApi";
import { MemberApi } from "@/features/Members/api";
import { studioMgmtApi } from "@/features/bughurd/api";
import boardSlice from "@/features/bughurd/slice";
import parameterizationSlice from "@/features/parameterization/slice";
import { AskAIApi } from "@/features/Global/chatApi";
import { companyMembersApi } from "@/bug-tracker/app/features/Members/api";
import { chatApi } from "@/features/AiApi/chatApi";
import { ipGeoLocationApi } from "@/bug-tracker/api/ipGeoLocationApi";

export const store = configureStore({
  reducer: {
    treeItem: treeItemReducer,
    apiCollection: apiCollectionSlice,
    appGlobal: globalDataSlice,
    roleAuth: roleReducer,
    companyMember: companyMembersReducer,
    role: rolesSlice,
    dataRefetch: dataRefetchSlice,
    emailAuth: emailAuthReducer,
    board: boardSlice,
    parameterization: parameterizationSlice,

    [CompanyMgmt.reducerPath]: CompanyMgmt.reducer,
    [IntegrationApi.reducerPath]: IntegrationApi.reducer,
    [SpecificationApi.reducerPath]: SpecificationApi.reducer,
    [MemberApi.reducerPath]: MemberApi.reducer,
    [RoleApi.reducerPath]: RoleApi.reducer,
    [ApiCollectionApi.reducerPath]: ApiCollectionApi.reducer,
    [ApiCollectionEnvApi.reducerPath]: ApiCollectionEnvApi.reducer,
    [ApiCollectionWorkspaceApi.reducerPath]: ApiCollectionWorkspaceApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [companyMembersApi.reducerPath]: companyMembersApi.reducer,
    [roleAuthMgmt.reducerPath]: roleAuthMgmt.reducer,
    [jiraProjectApi.reducerPath]: jiraProjectApi.reducer,
    [supportMgmtApi.reducerPath]: supportMgmtApi.reducer,
    [studioMgmtApi.reducerPath]: studioMgmtApi.reducer,
    [AskAIApi.reducerPath]: AskAIApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [ipGeoLocationApi.reducerPath]: ipGeoLocationApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      CompanyMgmt.middleware,
      IntegrationApi.middleware,
      SpecificationApi.middleware,
      MemberApi.middleware,
      RoleApi.middleware,
      ApiCollectionApi.middleware,
      ApiCollectionEnvApi.middleware,
      ApiCollectionWorkspaceApi.middleware,
      companyApi.middleware,
      companyMembersApi.middleware,
      roleAuthMgmt.middleware,
      jiraProjectApi.middleware,
      supportMgmtApi.middleware,
      studioMgmtApi.middleware,
      AskAIApi.middleware,
      chatApi.middleware,
      ipGeoLocationApi.middleware,
    ]),
  devTools: import.meta.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const resetAllApiState = () => (dispatch: AppDispatch) => {
  dispatch(CompanyMgmt.util.resetApiState());
  dispatch(IntegrationApi.util.resetApiState());
  dispatch(SpecificationApi.util.resetApiState());
  dispatch(MemberApi.util.resetApiState());
  dispatch(RoleApi.util.resetApiState());
  dispatch(ApiCollectionApi.util.resetApiState());
  dispatch(ApiCollectionEnvApi.util.resetApiState());
  dispatch(ApiCollectionWorkspaceApi.util.resetApiState());
  dispatch(companyApi.util.resetApiState());
  dispatch(roleAuthMgmt.util.resetApiState());
  dispatch(jiraProjectApi.util.resetApiState());
  dispatch(supportMgmtApi.util.resetApiState());
  dispatch(studioMgmtApi.util.resetApiState());
  dispatch(ipGeoLocationApi.util.resetApiState());
};
